import React from 'react';
import PropTypes from 'prop-types';
import ReactIcon from '../../Icons';

const zoomIcon = ReactIcon({ type: 'zoom_in' });

export default function AttributeValues({ values }) {
  return values.map((attributeValue) => (
    <div key={attributeValue.id} className="answer-concept-wrapper">
      <div className="answer-attribute-label-wrapper">
        <p className="answer-attribute-label">
          {attributeValue.attributeLabel || ''}
        </p>
        {attributeValue.attributeImage && (
          <div className="answer-attribute-image">
            <img src={attributeValue.attributeImage} alt="" />
            <button
              type="button"
              className="answer__image__button js-zoom-image"
              data-img-src={attributeValue.attributeImage}
            >
              {zoomIcon}
            </button>
          </div>
        )}
      </div>
      <div className="answer-attribute-text-wrapper">
        <p className="answer-attribute-text">{attributeValue.text || ''}</p>
        {attributeValue.image_url && (
          <div className="answer-attribute-value-image">
            <img src={attributeValue.image_url} alt="" />
            <button
              type="button"
              className="answer__image__button js-zoom-image"
              data-img-src={attributeValue.image_url}
            >
              {zoomIcon}
            </button>
          </div>
        )}
      </div>
    </div>
  ));
}

AttributeValues.propTypes = {
  values: PropTypes.array,
};
